import { css } from 'lit';
export const textareaStyles = css `
  .no-resize {
    resize: none;
  }
  .text-area {
    border: 1px solid var(--synapse-color-neutral-5);
    box-sizing: border-box;
    border-radius: 4px;
    background-color: var(--synapse-color-neutral-1);
    display: flex;
    font-family: inherit;
    color: var(--synapse-color-neutral-8);
  }

  .text-area svg,
  .text-area .icon {
    width: 20px;
    height: 20px;
    fill: var(--synapse-color-primary-3);
    align-self: center;
  }

  .text-area[disabled] svg,
  .text-area[disabled] .icon {
    fill: var(--synapse-color-neutral-5);
  }

  .text-area svg:first-child,
  .text-area .icon:first-child {
    margin-left: var(--spacing-s);
    margin-right: var(--spacing-xs);
  }

  .text-area svg:last-child,
  .text-area .icon:last-child {
    margin-right: var(--spacing-s);
    margin-left: var(--spacing-xs);
  }

  .text-area textarea {
    background-color: var(--synapse-color-neutral-1);
    border: none;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    width: 100%;
    font-family: inherit;
  }

  .text-area textarea:first-child {
    padding: 10px 8px;
  }

  .text-area textarea::placeholder {
    color: var(--synapse-color-neutral-5);
  }

  .text-area:hover {
    box-sizing: border-box;
    border: 1px solid var(--synapse-color-primary-4);
    transition: all 50ms;
  }

  .text-area textarea:focus {
    outline: none;
  }

  .text-area:focus-within {
    border: 2px solid var(--border-color-brand);
    outline: none;
    transition: all 50ms;
    padding: 1px;
  }

  .text-area[disabled] {
    background-color: var(--synapse-color-neutral-3);
    border: 1px solid var(--synapse-color-neutral-3);
    cursor: not-allowed;
  }

  .text-area[disabled] textarea {
    background-color: var(--synapse-color-neutral-3);
    cursor: not-allowed;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: var(--synapse-color-neutral-5);
    pointer-events: none;
  }

  .text-area.error {
    border: 1px solid var(--synapse-color-danger-3);
  }

  .text-area.error:focus-within {
    border: 2px solid var(--synapse-color-danger-3);
  }

  .text-area.error svg,
  .text-area.error .icon {
    fill: var(--synapse-color-danger-3);
  }
`;
export default textareaStyles;
